<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c8hf9M/images/cover.jpg?1699583384262" alt="This image is the cover for the book Shooting Vietnam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shooting Vietnam
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover what it was like to be amidst the action as a military photographer during the Vietnam War.</b><br/>  <br/><i>Shooting Vietnam</i> takes you there as you read the firsthand accounts and view the hundreds of photographs by men who lived the war through the lens of a camera. From the mid-1960s to the early 1970s, they documented everything from the horror of combat to the people and culture of a land they suddenly found themselves immersed in. Some juggled cameras with weapons as they fought to survive while carrying out their assignments to record the war. Others did not survive. <i>Shooting Vietnam</i> also finally brings recognition to these unheralded military combat photographers in Vietnam that documented the brutal, unpopular, and futile war.<br/>  <br/> Often, during a brief respite from trudging through swamps and rice paddies or jumping from a chopper into a hot landing zone, the photographers would wander the streets of villages or even downtown Saigon, curiously photographing a people and a culture so strange and different to them. It is these photographs, of a kinder, more personal nature, removed from the horror and death of war that they also share with the reader.<br/>    The accounts in this book come from young men thrust into a conflict half way around the world, and all who had their own unique perspective on the war. Some were seasoned photographers before the military, others had only recently held a camera for the first time.<br/>  <br/><b>“The photography is excellent . . . an essential read to anyone interested in the Vietnam War or conflict photography in general.” —<i>War History Online</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Brookes, Bob Hillerby, Joseph L.  Galloway
      </h2>
      
      <p class="authorDescription body article">Dan Brookes is a writer, photographer, and graphic artist. His tour in Vietnam gave him the travel bug and he still takes to the road, ocean, and air the world over adding to his collection of stories and pictures for his next books and photo exhibits. In addition to many other things, has been the production manager of a Hollywood-based gambling magazine, piloted a riverboat through the Amazon where he helped establish schools in tribal rainforest areas, ran a catering business that fed some of the most famous rock stars on tour, co-founded a UFO research group, and recently retired from Apple where he was a computer solutions consultant. He lives in Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d34d644c